var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comMap"},[_c('v-map'),(
      _vm.$route.path != '/index/runcontrol' &&
      _vm.$route.path != '/index/alarmInfo' &&
      _vm.$route.path != '/index/dataPlayback'
    )?_c('v-MapSwitch'):_vm._e(),_c('v-MeteoLegendTable'),_c('v-AltitudeControll'),_c('v-TimeControll')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }